module.exports = __webpack_public_path__ + "static/lighting-table-resize-572188d8a7b1bed0ef6ec390724b2629.png";